<template>
  <div id="app">
		<div class="container">
			<FileUploader @onUploaded="fileUrl = $event" v-if="!fileUrl" />
			<Player :fileUrl="fileUrl" @onNewFileUpload="fileUrl=''" v-else/>
		</div>
  </div>
</template>

<script>
import FileUploader from '@/components/FileUploader'
import Player from '@/components/Player';
export default {
  name: 'App',
  data: () => ({
    fileUrl: ''
  }),
  components: { Player, FileUploader }
}
</script>
